// // import React, {
// //   useEffect,
// //   useMemo,
// //   useState,
// // } from "react";

// // import {
// //   useLocation,
// //   useNavigate,
// //   useParams,
// // } from "react-router-dom";

// // import api from "../api/axiosConfig";
// // import "./PediatricFinalReviewScreen.css";

// // import finalReviewReports from "../data/finalReviewReports";
// // import PdfViewer from "../components/PdfViewer";
// // import ReviewSummaryPanel from "../components/pediatric/ReviewSummaryPanel";
// // import { FinalDoctorRecommendationFields } from "../types/finalDoctorRecommendation";
// // import { useFinalDoctorRecommendation } from "../hooks/useFinalDoctorRecommendation";
// // import { REPORT_RECOMMENDATION_MAP } from "../constants/reportRecommendationMap";
// // import { useAuth } from "../context/AuthContext";

// // const PediatricFinalReviewScreen = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const { doctor } = useAuth();

// //   const doctorName = doctor?.name ? `Dr. ${doctor.name}` : "";

// //   const sessionId = location.state?.sessionId;

// //   const reports = useMemo(() => finalReviewReports, []);

// //   const [active, setActive] = useState<any>(reports[0]);
// //   const [pdfUrl, setPdfUrl] = useState("");
// //   const [visited, setVisited] = useState<string[]>([]);
// //   const [finalDoctorSummary, setFinalDoctorSummary] = useState("");
  
// //   // State for loading PDFs
// //   const [loading, setLoading] = useState(false);
  
// //   // NEW: Separate state specifically for the final submission
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   const [showSummary, setShowSummary] = useState(false);

// //   const [localRecommendation, setLocalRecommendation] = useState<FinalDoctorRecommendationFields>(
// //     {} as FinalDoctorRecommendationFields
// //   );

// //   const { emrNumber } = useParams();

// //   const CURRENT_EMR = useMemo(() => {
// //     return emrNumber || "";
// //   }, [emrNumber]);

// //   const {
// //     loading: recommendationLoading,
// //     recommendation,
// //     saveField,
// //     saveAll,
// //     documentId,
// //   } = useFinalDoctorRecommendation(CURRENT_EMR, doctorName);

// //   useEffect(() => {
// //     setLocalRecommendation(recommendation);
// //   }, [recommendation]);

// //   const ENABLE_REPORT_PROTECTION = false;

// //   useEffect(() => {
// //     if (!ENABLE_REPORT_PROTECTION) {
// //       return;
// //     }

// //     const disableRightClick = (e: MouseEvent) => {
// //       e.preventDefault();
// //       e.stopPropagation();
// //     };

// //     const disableKeys = (e: KeyboardEvent) => {
// //       const key = e.key.toLowerCase();
// //       if ((e.ctrlKey && key === "s") || (e.ctrlKey && key === "p") || (e.ctrlKey && key === "u")) {
// //         e.preventDefault();
// //         e.stopPropagation();
// //         return false;
// //       }
// //       if (e.key === "F12") {
// //         e.preventDefault();
// //         e.stopPropagation();
// //         return false;
// //       }
// //       if (e.ctrlKey && e.shiftKey && (key === "i" || key === "j" || key === "c")) {
// //         e.preventDefault();
// //         e.stopPropagation();
// //         return false;
// //       }
// //       if (e.key === "PrintScreen") {
// //         navigator.clipboard.writeText("");
// //         e.preventDefault();
// //         e.stopPropagation();
// //         return false;
// //       }
// //     };

// //     const disableDrag = (e: DragEvent) => {
// //       e.preventDefault();
// //       e.stopPropagation();
// //     };

// //     const disableSelect = () => {
// //       document.body.style.userSelect = "none";
// //       (document.body.style as any).webkitUserSelect = "none";
// //     };

// //     const handleVisibility = () => {
// //       const viewer = document.getElementById("report-view-container");
// //       if (!viewer) return;
// //       if (document.hidden) {
// //         viewer.style.filter = "blur(20px)";
// //       } else {
// //         viewer.style.filter = "blur(0px)";
// //       }
// //     };

// //     disableSelect();
// //     document.addEventListener("contextmenu", disableRightClick);
// //     document.addEventListener("keydown", disableKeys);
// //     document.addEventListener("dragstart", disableDrag);
// //     document.addEventListener("selectstart", disableRightClick as any);
// //     document.addEventListener("visibilitychange", handleVisibility);

// //     return () => {
// //       document.removeEventListener("contextmenu", disableRightClick);
// //       document.removeEventListener("keydown", disableKeys);
// //       document.removeEventListener("dragstart", disableDrag);
// //       document.removeEventListener("selectstart", disableRightClick as any);
// //       document.removeEventListener("visibilitychange", handleVisibility);
// //     };
// //   }, []);

// //   useEffect(() => {
// //     loadReport(active);
// //   }, [active]);

// //   const loadReport = async (report: any) => {
// //     try {
// //       setLoading(true);

// //       if (pdfUrl) {
// //         URL.revokeObjectURL(pdfUrl);
// //       }
// //       setPdfUrl("");

// //       const reportUrl = `http://localhost:5000/api/v1/reports/${report.slug}/${CURRENT_EMR}`;
// //       console.log("FETCHING REPORT URL:", reportUrl);

// //       const response = await api.dataCollectionApi.get(reportUrl, {
// //         responseType: "blob",
// //       });

// //       if (response.data && response.data.size > 100) {
// //         const url = URL.createObjectURL(response.data);
// //         setPdfUrl(url);
// //       } else {
// //         console.error("Received empty PDF blob");
// //       }
// //     } catch (error) {
// //       console.error("LOAD REPORT ERROR", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const completedCount = visited.length;
// //   const totalCount = reports.length;
// //   const progress = Math.round((completedCount / totalCount) * 100);
// //   const allReportsReviewed = completedCount === totalCount;

// //   const handleFinalSubmit = async () => {
// //     try {
// //       if (!CURRENT_EMR) {
// //         alert("Cannot submit final review: missing EMR number.");
// //         return;
// //       }

// //       if (!sessionId) {
// //         alert("Cannot submit final review: missing session ID.");
// //         return;
// //       }

// //       // USE isSubmitting HERE instead of setLoading
// //       setIsSubmitting(true);

// //       console.log("FINAL REVIEW EMR =", CURRENT_EMR);
// //       console.log("FINAL REVIEW SESSION =", sessionId);

// //       const reportResponse = await api.dataCollectionApi.post(
// //         `/api/reports/generate-all/${CURRENT_EMR}`
// //       );

// //       console.log("REPORT GENERATE RESPONSE =", reportResponse.data);

// //       const response = await api.CenterworkflowApi.post(
// //         `/sessions/${sessionId}/tele-reporting/final_review/submit`
// //       );

// //       console.log("FINAL REVIEW RESPONSE =", response.data);

// //       alert("Final Review Submitted Successfully");

// //       navigate("/queue/tele-final-doctor");

// //       window.location.reload();
// //     } catch (error) {
// //       console.error("FINAL REVIEW ERROR =", error);
// //       alert("Failed to submit final review");
// //     } finally {
// //       // TURN OFF isSubmitting
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const [activeSummaryTab, setActiveSummaryTab] = useState<1 | 2 | 3>(1);

// //   const tabKeyMap = {
// //     1: "summaryTab1" as const,
// //     2: "summaryTab2" as const,
// //     3: "summaryTab3" as const,
// //   };

// //   const currentTabKey = tabKeyMap[activeSummaryTab];

// //   return (
// //     <div
// //       style={{
// //         display: "flex",
// //         height: "calc(100vh - 140px)",
// //         background: "#f7f8fc",
// //       }}
// //     >
// //       {/* POPUP OVERLAY NOW BOUND TO isSubmitting ONLY */}
// //       {isSubmitting && (
// //         <div className="final-review-loading-overlay">
// //           <div className="final-review-loading-card">
// //             <div className="final-review-spinner" />
// //             <h3>Submitting final review</h3>
// //             <p>
// //               Generating reports and storing them securely. Please wait while
// //               the process completes.
// //             </p>
// //           </div>
// //         </div>
// //       )}
      
// //       {/* LEFT PANEL */}
// //       <div
// //         style={{
// //           width: 320,
// //           background: "#ffffff",
// //           borderRight: "1px solid #e5e7eb",
// //           display: "flex",
// //           flexDirection: "column",
// //         }}
// //       >
// //         {/* HEADER */}
// //         <div
// //           style={{
// //             padding: 20,
// //             borderBottom: "1px solid #eee",
// //           }}
// //         >
// //           <h2
// //             style={{
// //               margin: 0,
// //               fontSize: 22,
// //               color: "#1f2937",
// //             }}
// //           >
// //             Final Review
// //           </h2>

// //           <p
// //             style={{
// //               marginTop: 8,
// //               fontSize: 13,
// //               color: "#6b7280",
// //             }}
// //           >
// //             EMR: {CURRENT_EMR}
// //           </p>

// //           {/* PROGRESS */}
// //           <div
// //             style={{
// //               marginTop: 15,
// //               background: "#f3f4f6",
// //               borderRadius: 10,
// //               overflow: "hidden",
// //               height: 10,
// //             }}
// //           >
// //             <div
// //               style={{
// //                 width: `${progress}%`,
// //                 height: "100%",
// //                 background: "#e55b73",
// //               }}
// //             />
// //           </div>

// //           <p
// //             style={{
// //               marginTop: 8,
// //               fontSize: 12,
// //               color: "#6b7280",
// //             }}
// //           >
// //             {completedCount}/{totalCount} reviewed
// //           </p>
// //         </div>

// //         {/* LEFT CONTENT */}
// //         <div
// //           style={{
// //             flex: 1,
// //             overflowY: "auto",
// //             padding: 15,
// //           }}
// //         >
// //           {/* SUMMARY BUTTON */}
// //           <button
// //             onClick={() => {
// //               if (allReportsReviewed) {
// //                 setShowSummary(true);
// //               }
// //             }}
// //             disabled={!allReportsReviewed}
// //             style={{
// //               width: "100%",
// //               marginBottom: 14,
// //               padding: "14px 16px",
// //               borderRadius: 12,
// //               border: "none",
// //               background: allReportsReviewed ? "#e55b73" : "#d1d5db",
// //               color: "#fff",
// //               fontWeight: 700,
// //               fontSize: 15,
// //               cursor: allReportsReviewed ? "pointer" : "not-allowed",
// //               opacity: allReportsReviewed ? 1 : 0.7,
// //             }}
// //           >
// //             Final Summary
// //           </button>

// //           {/* REPORTS */}
// //           {reports.map((item: any, index: number) => {
// //             const isActive = active.slug === item.slug;
// //             const isDone = visited.includes(item.slug);

// //             return (
// //               <button
// //                 key={item.slug}
// //                 onClick={() => {
// //                   setShowSummary(false);
// //                   setActive(item);
// //                 }}
// //                 style={{
// //                   width: "100%",
// //                   textAlign: "left",
// //                   marginBottom: 10,
// //                   padding: "14px 14px",
// //                   borderRadius: 12,
// //                   border: isActive ? "2px solid #e55b73" : "1px solid #e5e7eb",
// //                   background: isActive ? "#fff1f4" : "#fff",
// //                   cursor: "pointer",
// //                   transition: "0.2s",
// //                 }}
// //               >
// //                 <div
// //                   style={{
// //                     fontWeight: 600,
// //                     fontSize: 14,
// //                     color: "#111827",
// //                   }}
// //                 >
// //                   {index + 1}. {item.label}
// //                 </div>

// //                 <div
// //                   style={{
// //                     marginTop: 6,
// //                     fontSize: 12,
// //                     color: isDone ? "#16a34a" : "#9ca3af",
// //                   }}
// //                 >
// //                   {isDone ? "Reviewed ✓" : "Pending"}
// //                 </div>
// //               </button>
// //             );
// //           })}
// //         </div>
// //       </div>

// //       {/* RIGHT PANEL */}
// //       <div
// //         style={{
// //           flex: 1,
// //           display: "flex",
// //           flexDirection: "column",
// //         }}
// //       >
// //         {/* TOP BAR */}
// //         <div
// //           style={{
// //             padding: "18px 24px",
// //             background: "#ffffff",
// //             borderBottom: "1px solid #eee",
// //             display: "flex",
// //             justifyContent: "space-between",
// //             alignItems: "center",
// //           }}
// //         >
// //           <div>
// //             <h3
// //               style={{
// //                 margin: 0,
// //                 fontSize: 24,
// //                 color: "#111827",
// //               }}
// //             >
// //               {showSummary ? "Final Summary" : active.label}
// //             </h3>

// //             <p
// //               style={{
// //                 margin: "6px 0 0",
// //                 color: "#6b7280",
// //                 fontSize: 13,
// //               }}
// //             >
// //               Pediatric Final Medical Review Panel
// //             </p>
// //           </div>

// //           <div
// //             style={{
// //               background: "#fff1f4",
// //               color: "#e55b73",
// //               padding: "8px 14px",
// //               borderRadius: 30,
// //               fontWeight: 700,
// //               fontSize: 13,
// //             }}
// //           >
// //             {loading ? "Loading..." : "Hello Doctor Have a Good Day!"}
// //           </div>
// //         </div>

// //         {/* MAIN CONTENT */}
// //         <div
// //           style={{
// //             flex: 1,
// //             padding: 18,
// //           }}
// //         >
// //           <div
// //             style={{
// //               background: "#fff",
// //               borderRadius: 18,
// //               overflow: "hidden",
// //               height: "100%",
// //               boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
// //               padding: showSummary ? 30 : 0,
// //             }}
// //           >
// //             {/* SUMMARY SCREEN */}
// //             {showSummary ? (
// //               <div>
// //                 {/* TABS FOR THE SUMMARY */}
// //                 <div style={{ display: "flex", gap: 10, marginBottom: 15 }}>
// //                   {[1, 2, 3].map((tabNum) => {
// //                     const isTabActive = activeSummaryTab === tabNum;
// //                     return (
// //                       <button
// //                         key={tabNum}
// //                         onClick={() => setActiveSummaryTab(tabNum as 1 | 2 | 3)}
// //                         style={{
// //                           padding: "10px 22px",
// //                           borderRadius: 8,
// //                           border: isTabActive ? "2px solid #e55b73" : "1px solid #ddd",
// //                           background: isTabActive ? "#fff1f4" : "#fff",
// //                           color: isTabActive ? "#e55b73" : "#333",
// //                           fontWeight: 700,
// //                           cursor: "pointer",
// //                           fontSize: 14,
// //                           transition: "0.2s",
// //                         }}
// //                       >
// //                         Tab {tabNum}
// //                       </button>
// //                     );
// //                   })}
// //                 </div>

// //                 <h2
// //                   style={{
// //                     marginBottom: 15,
// //                     color: "#111827",
// //                     fontSize: 20,
// //                   }}
// //                 >
// //                   Final Doctor Summary — Tab {activeSummaryTab}
// //                 </h2>

// //                 <textarea
// //                   placeholder={`Write summary for Tab ${activeSummaryTab}...`}
// //                   value={localRecommendation[currentTabKey] || ""}
// //                   onChange={(e) => {
// //                     const val = e.target.value;
// //                     setLocalRecommendation((prev) => ({
// //                       ...prev,
// //                       [currentTabKey]: val,
// //                     }));
// //                   }}
// //                   onBlur={async () => {
// //                     await saveField(currentTabKey, localRecommendation[currentTabKey] || "");
// //                   }}
// //                   style={{
// //                     width: "100%",
// //                     minHeight: 280,
// //                     borderRadius: 14,
// //                     border: "1px solid #ddd",
// //                     padding: 20,
// //                     fontSize: 15,
// //                     resize: "none",
// //                     outline: "none",
// //                   }}
// //                 />

// //                 <button
// //                   onClick={handleFinalSubmit}
// //                   disabled={isSubmitting} // UPDATED
// //                   style={{
// //                     marginTop: 20,
// //                     padding: "14px 24px",
// //                     border: "none",
// //                     borderRadius: 10,
// //                     background: "#e55b73",
// //                     color: "#fff",
// //                     fontWeight: 700,
// //                     cursor: isSubmitting ? "not-allowed" : "pointer",
// //                     opacity: isSubmitting ? 0.65 : 1,
// //                     fontSize: 15,
// //                   }}
// //                 >
// //                   {/* UPDATED */}
// //                   {isSubmitting ? "Submitting final review..." : "Submit Final Review"} 
// //                 </button>
// //               </div>
// //             ) : pdfUrl ? (
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   gap: 20,
// //                   height: "calc(100vh - 240px)",
// //                   overflow: "hidden",
// //                 }}
// //               >
// //                 {/* PDF Viewer */}
// //                 <div
// //                   style={{
// //                     flex: 7,
// //                     background: "#fff",
// //                     borderRadius: 14,
// //                     overflow: "hidden",
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     height: "100%",
// //                   }}
// //                 >
// //                   <PdfViewer file={pdfUrl} />
// //                 </div>

// //                 {/* Summary Panel */}
// //                 <div
// //                   style={{
// //                     flex: 3,
// //                     background: "#fff",
// //                     borderRadius: 14,
// //                     boxShadow: "0 4px 12px rgba(0,0,0,.08)",
// //                     overflow: "hidden",
// //                   }}
// //                 >
// //                   <ReviewSummaryPanel
// //                     reportName={active.label}
// //                     summary={
// //                       localRecommendation[REPORT_RECOMMENDATION_MAP[active.slug] || active.slug] || ""
// //                     }
// //                     onSummaryChange={(value) => {
// //                       const field = REPORT_RECOMMENDATION_MAP[active.slug] || active.slug;
// //                       if (!field) return;

// //                       setLocalRecommendation((prev) => ({
// //                         ...prev,
// //                         [field]: value,
// //                       }));
// //                     }}
// //                     onSubmit={async () => {
// //                       const field = REPORT_RECOMMENDATION_MAP[active.slug] || active.slug;
// //                       if (!field) return;

// //                       await saveField(field, localRecommendation[field]);

// //                       setVisited((prev) =>
// //                         prev.includes(active.slug) ? prev : [...prev, active.slug]
// //                       );

// //                       const currentIndex = reports.findIndex((r) => r.slug === active.slug);

// //                       if (currentIndex < reports.length - 1) {
// //                         setActive(reports[currentIndex + 1]);
// //                       }
// //                     }}
// //                   />
// //                 </div>
// //               </div>
// //             ) : (
// //               <div
// //                 style={{
// //                   padding: 0,
// //                   width: "100%",
// //                   height: "100%",
// //                   display: "flex",
// //                   flexDirection: "column",
// //                 }}
// //               >
// //                 {loading ? (
// //                   <div style={{ padding: 40, textAlign: "center" }}>Loading section report...</div>
// //                 ) : pdfUrl ? (
// //                   <iframe
// //                     src={`${pdfUrl}#toolbar=0`}
// //                     style={{ width: "100%", height: "100%", border: "none", minHeight: "700px" }}
// //                     title="Section Report Preview"
// //                   />
// //                 ) : (
// //                   <div style={{ padding: 40 }}>No Report Loaded</div>
// //                 )}
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default PediatricFinalReviewScreen;




// import React, { useEffect, useMemo, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import api from "../api/axiosConfig";
// import "./PediatricFinalReviewScreen.css";

// import finalReviewReports from "../data/finalReviewReports";
// import PdfViewer from "../components/PdfViewer";
// import ReviewSummaryPanel from "../components/pediatric/ReviewSummaryPanel";
// import { FinalDoctorRecommendationFields } from "../types/finalDoctorRecommendation";
// import { useFinalDoctorRecommendation } from "../hooks/useFinalDoctorRecommendation";
// import { REPORT_RECOMMENDATION_MAP } from "../constants/reportRecommendationMap";
// import { useAuth } from "../context/AuthContext";

// const PediatricFinalReviewScreen = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { doctor } = useAuth();

//   const doctorName = doctor?.name ? `Dr. ${doctor.name}` : "";
//   const sessionId = location.state?.sessionId;
//   const reports = useMemo(() => finalReviewReports, []);

//   const [active, setActive] = useState<any>(reports[0]);
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [visited, setVisited] = useState<string[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showSummary, setShowSummary] = useState(false);

//   const [localRecommendation, setLocalRecommendation] = useState<FinalDoctorRecommendationFields>(
//     {} as FinalDoctorRecommendationFields
//   );

//   const { emrNumber } = useParams();

//   const CURRENT_EMR = useMemo(() => {
//     return emrNumber || "";
//   }, [emrNumber]);

//   const {
//     loading: recommendationLoading,
//     recommendation,
//     saveField,
//     documentId,
//   } = useFinalDoctorRecommendation(CURRENT_EMR, doctorName);

//   useEffect(() => {
//     setLocalRecommendation(recommendation);
//   }, [recommendation]);

//   const ENABLE_REPORT_PROTECTION = false;

//   useEffect(() => {
//     if (!ENABLE_REPORT_PROTECTION) return;
//     const disableRightClick = (e: MouseEvent) => { e.preventDefault(); e.stopPropagation(); };
//     const disableKeys = (e: KeyboardEvent) => {
//       const key = e.key.toLowerCase();
//       if ((e.ctrlKey && key === "s") || (e.ctrlKey && key === "p") || (e.ctrlKey && key === "u")) { e.preventDefault(); e.stopPropagation(); return false; }
//       if (e.key === "F12") { e.preventDefault(); e.stopPropagation(); return false; }
//       if (e.ctrlKey && e.shiftKey && (key === "i" || key === "j" || key === "c")) { e.preventDefault(); e.stopPropagation(); return false; }
//       if (e.key === "PrintScreen") { navigator.clipboard.writeText(""); e.preventDefault(); e.stopPropagation(); return false; }
//     };
//     const disableDrag = (e: DragEvent) => { e.preventDefault(); e.stopPropagation(); };
//     const disableSelect = () => {
//       document.body.style.userSelect = "none";
//       (document.body.style as any).webkitUserSelect = "none";
//     };
//     const handleVisibility = () => {
//       const viewer = document.getElementById("report-view-container");
//       if (!viewer) return;
//       if (document.hidden) viewer.style.filter = "blur(20px)";
//       else viewer.style.filter = "blur(0px)";
//     };

//     disableSelect();
//     document.addEventListener("contextmenu", disableRightClick);
//     document.addEventListener("keydown", disableKeys);
//     document.addEventListener("dragstart", disableDrag);
//     document.addEventListener("selectstart", disableRightClick as any);
//     document.addEventListener("visibilitychange", handleVisibility);

//     return () => {
//       document.removeEventListener("contextmenu", disableRightClick);
//       document.removeEventListener("keydown", disableKeys);
//       document.removeEventListener("dragstart", disableDrag);
//       document.removeEventListener("selectstart", disableRightClick as any);
//       document.removeEventListener("visibilitychange", handleVisibility);
//     };
//   }, []);

//   useEffect(() => {
//     loadReport(active);
//   }, [active]);

//   const loadReport = async (report: any) => {
//     try {
//       setLoading(true);
//       if (pdfUrl) URL.revokeObjectURL(pdfUrl);
//       setPdfUrl("");

//       // const reportUrl = `http://localhost:4013/api/v1/reports/${report.slug}/${CURRENT_EMR}`;
//       const reportUrl = `api/v1/reports/${report.slug}/${CURRENT_EMR}`;
//       const response = await api.ReportingApi.get(reportUrl, { responseType: "blob" });

//       if (response.data && response.data.size > 100) {
//         const url = URL.createObjectURL(response.data);
//         setPdfUrl(url);
//       } else {
//         console.error("Received empty PDF blob");
//       }
//     } catch (error) {
//       console.error("LOAD REPORT ERROR", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const completedCount = visited.length;
//   const totalCount = reports.length;
//   const progress = Math.round((completedCount / totalCount) * 100);
//   const allReportsReviewed = completedCount === totalCount;

//   const handleFinalSubmit = async () => {
//     try {
//       if (!CURRENT_EMR || !sessionId) {
//         alert("Cannot submit final review: missing EMR or Session ID.");
//         return;
//       }

//       setIsSubmitting(true);

//       // BACKEND RULE: The overall impressions MUST be saved last to trigger the final completion check.[cite: 1]
//       await saveField(
//         "reviewingPaediatricianOverallImpressions",
//         localRecommendation.reviewingPaediatricianOverallImpressions || ""
//       );

//       const reportResponse = await api.dataCollectionApi.post(
//         `/api/reports/generate-all/${CURRENT_EMR}`
//       );
//       console.log("REPORT GENERATE RESPONSE =", reportResponse.data);

//       const response = await api.CenterworkflowApi.post(
//         `/sessions/${sessionId}/tele-reporting/final_review/submit`
//       );
//       console.log("FINAL REVIEW RESPONSE =", response.data);

//       alert("Final Review Submitted Successfully");
//       navigate("/queue/tele-final-doctor");
//       window.location.reload();

//     } catch (error: any) {
//       console.error("FINAL REVIEW ERROR =", error);
//       if (error?.response?.status === 400 && error.response.data?.details?.missingFields) {
//         const missing = error.response.data.details.missingFields.join(", ");
//         alert(`Cannot submit. Please complete the following missing sections:\n\n${missing}`);
//       } else {
//         alert("Failed to submit final review");
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const [activeSummaryTab, setActiveSummaryTab] = useState<1 | 2 | 3>(1);

//   // FIX: Maps UI Tabs directly to the correct backend fields[cite: 1]
//   const tabKeyMap = {
//     1: "parentSummary" as const,
//     2: "parentNextSteps" as const,
//     3: "reviewingPaediatricianOverallImpressions" as const,
//   };

//   const tabTitleMap = {
//     1: "Parent Summary",
//     2: "Parent - What We'd Like You to Do Next",
//     3: "Reviewing Paediatrician's Overall Impressions",
//   };

//   const currentTabKey = tabKeyMap[activeSummaryTab];
//   const currentTabTitle = tabTitleMap[activeSummaryTab];

//   return (
//     <div style={{ display: "flex", height: "calc(100vh - 140px)", background: "#f7f8fc" }}>
      
//       {isSubmitting && (
//         <div className="final-review-loading-overlay">
//           <div className="final-review-loading-card">
//             <div className="final-review-spinner" />
//             <h3>Submitting final review</h3>
//             <p>Generating reports and storing them securely. Please wait while the process completes.</p>
//           </div>
//         </div>
//       )}
      
//       {/* LEFT PANEL */}
//       <div style={{ width: 320, background: "#ffffff", borderRight: "1px solid #e5e7eb", display: "flex", flexDirection: "column" }}>
//         <div style={{ padding: 20, borderBottom: "1px solid #eee" }}>
//           <h2 style={{ margin: 0, fontSize: 22, color: "#1f2937" }}>Final Review</h2>
//           <p style={{ marginTop: 8, fontSize: 13, color: "#6b7280" }}>EMR: {CURRENT_EMR}</p>
//           <div style={{ marginTop: 15, background: "#f3f4f6", borderRadius: 10, overflow: "hidden", height: 10 }}>
//             <div style={{ width: `${progress}%`, height: "100%", background: "#e55b73" }} />
//           </div>
//           <p style={{ marginTop: 8, fontSize: 12, color: "#6b7280" }}>{completedCount}/{totalCount} reviewed</p>
//         </div>

//         <div style={{ flex: 1, overflowY: "auto", padding: 15 }}>
//           <button
//             onClick={() => { if (allReportsReviewed) setShowSummary(true); }}
//             disabled={!allReportsReviewed}
//             style={{
//               width: "100%", marginBottom: 14, padding: "14px 16px", borderRadius: 12, border: "none",
//               background: allReportsReviewed ? "#e55b73" : "#d1d5db", color: "#fff", fontWeight: 700,
//               fontSize: 15, cursor: allReportsReviewed ? "pointer" : "not-allowed", opacity: allReportsReviewed ? 1 : 0.7,
//             }}
//           >
//             Final Summary
//           </button>

//           {reports.map((item: any, index: number) => {
//             const isActive = active.slug === item.slug && !showSummary;
//             const isDone = visited.includes(item.slug);

//             return (
//               <button
//                 key={item.slug}
//                 onClick={() => { setShowSummary(false); setActive(item); }}
//                 style={{
//                   width: "100%", textAlign: "left", marginBottom: 10, padding: "14px 14px", borderRadius: 12,
//                   border: isActive ? "2px solid #e55b73" : "1px solid #e5e7eb",
//                   background: isActive ? "#fff1f4" : "#fff", cursor: "pointer", transition: "0.2s",
//                 }}
//               >
//                 <div style={{ fontWeight: 600, fontSize: 14, color: "#111827" }}>{index + 1}. {item.label}</div>
//                 <div style={{ marginTop: 6, fontSize: 12, color: isDone ? "#16a34a" : "#9ca3af" }}>
//                   {isDone ? "Reviewed ✓" : "Pending"}
//                 </div>
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* RIGHT PANEL */}
//       <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
//         <div style={{ padding: "18px 24px", background: "#ffffff", borderBottom: "1px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <div>
//             <h3 style={{ margin: 0, fontSize: 24, color: "#111827" }}>{showSummary ? "Final Summary" : active.label}</h3>
//             <p style={{ margin: "6px 0 0", color: "#6b7280", fontSize: 13 }}>Pediatric Final Medical Review Panel</p>
//           </div>
//           <div style={{ background: "#fff1f4", color: "#e55b73", padding: "8px 14px", borderRadius: 30, fontWeight: 700, fontSize: 13 }}>
//             {loading ? "Loading..." : "Hello Doctor Have a Good Day!"}
//           </div>
//         </div>

//         <div style={{ flex: 1, padding: 18 }}>
//           <div style={{ background: "#fff", borderRadius: 18, overflow: "hidden", height: "100%", boxShadow: "0 8px 25px rgba(0,0,0,0.05)", padding: showSummary ? 30 : 0 }}>
            
//             {showSummary ? (
//               <div>
//                 <div style={{ display: "flex", gap: 10, marginBottom: 15 }}>
//                   {[1, 2, 3].map((tabNum) => {
//                     const isTabActive = activeSummaryTab === tabNum;
//                     return (
//                       <button
//                         key={tabNum}
//                         onClick={() => setActiveSummaryTab(tabNum as 1 | 2 | 3)}
//                         style={{
//                           padding: "10px 22px", borderRadius: 8, border: isTabActive ? "2px solid #e55b73" : "1px solid #ddd",
//                           background: isTabActive ? "#fff1f4" : "#fff", color: isTabActive ? "#e55b73" : "#333",
//                           fontWeight: 700, cursor: "pointer", fontSize: 14, transition: "0.2s",
//                         }}
//                       >
//                         {tabTitleMap[tabNum as 1 | 2 | 3]}
//                       </button>
//                     );
//                   })}
//                 </div>

//                 <h2 style={{ marginBottom: 15, color: "#111827", fontSize: 20 }}>{currentTabTitle}</h2>

//                 <textarea
//                   placeholder={`Write ${currentTabTitle}...`}
//                   value={localRecommendation[currentTabKey] || ""}
//                   onChange={(e) => {
//                     const val = e.target.value;
//                     setLocalRecommendation((prev) => ({ ...prev, [currentTabKey]: val }));
//                   }}
//                   onBlur={async () => {
//                     // Prevent early final submission checks on blur for Tab 3
//                     if (currentTabKey !== "reviewingPaediatricianOverallImpressions") {
//                       await saveField(currentTabKey, localRecommendation[currentTabKey] || "");
//                     }
//                   }}
//                   style={{
//                     width: "100%", minHeight: 280, borderRadius: 14, border: "1px solid #ddd",
//                     padding: 20, fontSize: 15, resize: "none", outline: "none",
//                   }}
//                 />

//                 <button
//                   onClick={handleFinalSubmit}
//                   disabled={isSubmitting}
//                   style={{
//                     marginTop: 20, padding: "14px 24px", border: "none", borderRadius: 10,
//                     background: "#e55b73", color: "#fff", fontWeight: 700,
//                     cursor: isSubmitting ? "not-allowed" : "pointer", opacity: isSubmitting ? 0.65 : 1, fontSize: 15,
//                   }}
//                 >
//                   {isSubmitting ? "Submitting final review..." : "Submit Final Review"} 
//                 </button>
//               </div>
//             ) : pdfUrl ? (
//               <div style={{ display: "flex", gap: 20, height: "calc(100vh - 240px)", overflow: "hidden" }}>
//                 <div style={{ flex: 7, background: "#fff", borderRadius: 14, overflow: "hidden", display: "flex", flexDirection: "column", height: "100%" }}>
//                   <PdfViewer file={pdfUrl} />
//                 </div>
//                 <div style={{ flex: 3, background: "#fff", borderRadius: 14, boxShadow: "0 4px 12px rgba(0,0,0,.08)", overflow: "hidden" }}>
//                   <ReviewSummaryPanel
//                     reportName={active.label}
//                     summary={localRecommendation[REPORT_RECOMMENDATION_MAP[active.slug] || active.slug] || ""}
//                     onSummaryChange={(value) => {
//                       const field = REPORT_RECOMMENDATION_MAP[active.slug] || active.slug;
//                       if (!field) return;
//                       setLocalRecommendation((prev) => ({ ...prev, [field]: value }));
//                     }}
//                     onSubmit={async () => {
//                       const field = REPORT_RECOMMENDATION_MAP[active.slug] || active.slug;
//                       if (!field) return;

//                       await saveField(field, localRecommendation[field]);
//                       setVisited((prev) => prev.includes(active.slug) ? prev : [...prev, active.slug]);

//                       const currentIndex = reports.findIndex((r) => r.slug === active.slug);
//                       if (currentIndex < reports.length - 1) setActive(reports[currentIndex + 1]);
//                     }}
//                   />
//                 </div>
//               </div>
//             ) : (
//               <div style={{ padding: 0, width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
//                 {loading ? <div style={{ padding: 40, textAlign: "center" }}>Loading section report...</div> : <div style={{ padding: 40 }}>No Report Loaded</div>}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PediatricFinalReviewScreen;








import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../api/axiosConfig";
import "./PediatricFinalReviewScreen.css";

import finalReviewReports from "../data/finalReviewReports";
import PdfViewer from "../components/PdfViewer";
import ReviewSummaryPanel from "../components/pediatric/ReviewSummaryPanel";
import { FinalDoctorRecommendationFields } from "../types/finalDoctorRecommendation";
import { useFinalDoctorRecommendation } from "../hooks/useFinalDoctorRecommendation";
import { REPORT_RECOMMENDATION_MAP } from "../constants/reportRecommendationMap";
import { useAuth } from "../context/AuthContext";

const PediatricFinalReviewScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { doctor, currentUser } = useAuth();

  const doctorName = doctor?.name ? `Dr. ${doctor.name}` : "";
  const sessionId = location.state?.sessionId;
  const reports = useMemo(() => finalReviewReports, []);

  const [active, setActive] = useState<any>(reports[0]);
  const [pdfUrl, setPdfUrl] = useState("");
  const [visited, setVisited] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSummary, setShowSummary] = useState(false);

  const [localRecommendation, setLocalRecommendation] = useState<FinalDoctorRecommendationFields>(
    {} as FinalDoctorRecommendationFields
  );

  const { emrNumber } = useParams();

  const CURRENT_EMR = useMemo(() => {
    return emrNumber || "";
  }, [emrNumber]);

  const {
    loading: recommendationLoading,
    recommendation,
    saveField,
    documentId,
  } = useFinalDoctorRecommendation(CURRENT_EMR, doctorName);

  useEffect(() => {
    setLocalRecommendation(recommendation);
  }, [recommendation]);

  const ENABLE_REPORT_PROTECTION = false;

  useEffect(() => {
    if (!ENABLE_REPORT_PROTECTION) return;
    const disableRightClick = (e: MouseEvent) => { e.preventDefault(); e.stopPropagation(); };
    const disableKeys = (e: KeyboardEvent) => {
      const key = e.key.toLowerCase();
      if ((e.ctrlKey && key === "s") || (e.ctrlKey && key === "p") || (e.ctrlKey && key === "u")) { e.preventDefault(); e.stopPropagation(); return false; }
      if (e.key === "F12") { e.preventDefault(); e.stopPropagation(); return false; }
      if (e.ctrlKey && e.shiftKey && (key === "i" || key === "j" || key === "c")) { e.preventDefault(); e.stopPropagation(); return false; }
      if (e.key === "PrintScreen") { navigator.clipboard.writeText(""); e.preventDefault(); e.stopPropagation(); return false; }
    };
    const disableDrag = (e: DragEvent) => { e.preventDefault(); e.stopPropagation(); };
    const disableSelect = () => {
      document.body.style.userSelect = "none";
      (document.body.style as any).webkitUserSelect = "none";
    };
    const handleVisibility = () => {
      const viewer = document.getElementById("report-view-container");
      if (!viewer) return;
      if (document.hidden) viewer.style.filter = "blur(20px)";
      else viewer.style.filter = "blur(0px)";
    };

    disableSelect();
    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableKeys);
    document.addEventListener("dragstart", disableDrag);
    document.addEventListener("selectstart", disableRightClick as any);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeys);
      document.removeEventListener("dragstart", disableDrag);
      document.removeEventListener("selectstart", disableRightClick as any);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  useEffect(() => {
    loadReport(active);
  }, [active]);

  const loadReport = async (report: any) => {
    try {
      setLoading(true);
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
      setPdfUrl("");

      // const reportUrl = `http://localhost:4013/api/v1/reports/${report.slug}/${CURRENT_EMR}`;
      const reportUrl = `api/v1/reports/${report.slug}/${CURRENT_EMR}`;
      const response = await api.ReportingApi.get(reportUrl, { responseType: "blob" });

      if (response.data && response.data.size > 100) {
        const url = URL.createObjectURL(response.data);
        setPdfUrl(url);
      } else {
        console.error("Received empty PDF blob");
      }
    } catch (error) {
      console.error("LOAD REPORT ERROR", error);
    } finally {
      setLoading(false);
    }
  };

  const completedCount = visited.length;
  const totalCount = reports.length;
  const progress = Math.round((completedCount / totalCount) * 100);
  const allReportsReviewed = completedCount === totalCount;

  const handleFinalSubmit = async () => {
    try {
      if (!CURRENT_EMR || !sessionId) {
        alert("Cannot submit final review: missing EMR or Session ID.");
        return;
      }

      const doctorId = currentUser?.user?._id;

      if (!doctorId) {
        console.error("Doctor ID is missing from currentUser:", currentUser);
        alert("Doctor ID missing. Please login again.");
        return;
      }

      setIsSubmitting(true);

      // BACKEND RULE: The overall impressions MUST be saved last to trigger the final completion check.[cite: 1]
      await saveField(
        "reviewingPaediatricianOverallImpressions",
        localRecommendation.reviewingPaediatricianOverallImpressions || ""
      );

      const reportResponse = await api.dataCollectionApi.post(
        `/api/reports/generate-all/${CURRENT_EMR}`
      );
      console.log("REPORT GENERATE RESPONSE =", reportResponse.data);

      const response = await api.CenterworkflowApi.post(
        `/sessions/${sessionId}/tele-reporting/final_review/submit`,
        {
          doctorId,
        }
      );
      console.log("FINAL REVIEW RESPONSE =", response.data);

      alert("Final Review Submitted Successfully");
      navigate("/queue/tele-final-doctor");
      window.location.reload();

    } catch (error: any) {
      console.error("FINAL REVIEW ERROR =", error);
      if (error?.response?.status === 400 && error.response.data?.details?.missingFields) {
        const missing = error.response.data.details.missingFields.join(", ");
        alert(`Cannot submit. Please complete the following missing sections:\n\n${missing}`);
      } else {
        alert("Failed to submit final review");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const [activeSummaryTab, setActiveSummaryTab] = useState<1 | 2 | 3>(1);

  // FIX: Maps UI Tabs directly to the correct backend fields[cite: 1]
  const tabKeyMap = {
    1: "parentSummary" as const,
    2: "parentNextSteps" as const,
    3: "reviewingPaediatricianOverallImpressions" as const,
  };

  const tabTitleMap = {
    1: "Parent Summary",
    2: "Parent - What We'd Like You to Do Next",
    3: "Reviewing Paediatrician's Overall Impressions",
  };

  const currentTabKey = tabKeyMap[activeSummaryTab];
  const currentTabTitle = tabTitleMap[activeSummaryTab];

  return (
    <div style={{ display: "flex", height: "calc(100vh - 218px)", background: "#f7f8fc" }}>
      
      {isSubmitting && (
        <div className="final-review-loading-overlay">
          <div className="final-review-loading-card">
            <div className="final-review-spinner" />
            <h3>Submitting final review</h3>
            <p>Generating reports and storing them securely. Please wait while the process completes.</p>
          </div>
        </div>
      )}
      
      {/* LEFT PANEL */}
      <div style={{ width: 320, background: "#ffffff", borderRight: "1px solid #e5e7eb", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: 20, borderBottom: "1px solid #eee" }}>
          <h2 style={{ margin: 0, fontSize: 22, color: "#1f2937" }}>Final Review</h2>
          <p style={{ marginTop: 8, fontSize: 13, color: "#6b7280" }}>EMR: {CURRENT_EMR}</p>
          <div style={{ marginTop: 15, background: "#f3f4f6", borderRadius: 10, overflow: "hidden", height: 10 }}>
            <div style={{ width: `${progress}%`, height: "100%", background: "#e55b73" }} />
          </div>
          <p style={{ marginTop: 8, fontSize: 12, color: "#6b7280" }}>{completedCount}/{totalCount} reviewed</p>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: 15 }}>
          {reports.map((item: any, index: number) => {
            const isActive = active.slug === item.slug && !showSummary;
            const isDone = visited.includes(item.slug);

            return (
              <button
                key={item.slug}
                onClick={() => { setShowSummary(false); setActive(item); }}
                style={{
                  width: "100%", textAlign: "left", marginBottom: 10, padding: "14px 14px", borderRadius: 12,
                  border: isActive ? "2px solid #e55b73" : "1px solid #e5e7eb",
                  background: isActive ? "#fff1f4" : "#fff", cursor: "pointer", transition: "0.2s",
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 14, color: "#111827" }}>{index + 1}. {item.label}</div>
                <div style={{ marginTop: 6, fontSize: 12, color: isDone ? "#16a34a" : "#9ca3af" }}>
                  {isDone ? "Reviewed ✓" : "Pending"}
                </div>
              </button>
            );
          })}

          <button
            onClick={() => {
              if (allReportsReviewed) setShowSummary(true);
            }}
            disabled={!allReportsReviewed}
            style={{
              width: "100%",
              marginTop: 4,
              marginBottom: 10,
              padding: "14px 16px",
              borderRadius: 12,
              border: "none",
              background: allReportsReviewed ? "#e55b73" : "#d1d5db",
              color: "#fff",
              fontWeight: 700,
              fontSize: 15,
              cursor: allReportsReviewed ? "pointer" : "not-allowed",
              opacity: allReportsReviewed ? 1 : 0.7,
            }}
          >
            Final Summary
          </button>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "18px 24px", background: "#ffffff", borderBottom: "1px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h3 style={{ margin: 0, fontSize: 24, color: "#111827" }}>{showSummary ? "Final Summary" : active.label}</h3>
            <p style={{ margin: "6px 0 0", color: "#6b7280", fontSize: 13 }}>Pediatric Final Medical Review Panel</p>
          </div>
          <div style={{ background: "#fff1f4", color: "#e55b73", padding: "8px 14px", borderRadius: 30, fontWeight: 700, fontSize: 13 }}>
            {loading ? "Loading..." : "Hello Doctor Have a Good Day!"}
          </div>
        </div>

        <div style={{ flex: 1, padding: 18 }}>
          <div style={{ background: "#fff", borderRadius: 18, overflow: "hidden", height: "100%", boxShadow: "0 8px 25px rgba(0,0,0,0.05)", padding: showSummary ? 30 : 0 }}>
            
            {showSummary ? (
              <div>
                <div style={{ display: "flex", gap: 10, marginBottom: 15 }}>
                  {[1, 2, 3].map((tabNum) => {
                    const isTabActive = activeSummaryTab === tabNum;
                    return (
                      <button
                        key={tabNum}
                        onClick={() => setActiveSummaryTab(tabNum as 1 | 2 | 3)}
                        style={{
                          padding: "10px 22px", borderRadius: 8, border: isTabActive ? "2px solid #e55b73" : "1px solid #ddd",
                          background: isTabActive ? "#fff1f4" : "#fff", color: isTabActive ? "#e55b73" : "#333",
                          fontWeight: 700, cursor: "pointer", fontSize: 14, transition: "0.2s",
                        }}
                      >
                        {tabTitleMap[tabNum as 1 | 2 | 3]}
                      </button>
                    );
                  })}
                </div>

                <h2 style={{ marginBottom: 15, color: "#111827", fontSize: 20 }}>{currentTabTitle}</h2>

                <textarea
                  placeholder={`Write ${currentTabTitle}...`}
                  value={localRecommendation[currentTabKey] || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    setLocalRecommendation((prev) => ({ ...prev, [currentTabKey]: val }));
                  }}
                  onBlur={async () => {
                    // Prevent early final submission checks on blur for Tab 3
                    if (currentTabKey !== "reviewingPaediatricianOverallImpressions") {
                      await saveField(currentTabKey, localRecommendation[currentTabKey] || "");
                    }
                  }}
                  style={{
                    width: "100%", minHeight: 280, borderRadius: 14, border: "1px solid #ddd",
                    padding: 20, fontSize: 15, resize: "none", outline: "none",
                  }}
                />

                <button
                  onClick={handleFinalSubmit}
                  disabled={isSubmitting}
                  style={{
                    marginTop: 20, padding: "14px 24px", border: "none", borderRadius: 10,
                    background: "#e55b73", color: "#fff", fontWeight: 700,
                    cursor: isSubmitting ? "not-allowed" : "pointer", opacity: isSubmitting ? 0.65 : 1, fontSize: 15,
                  }}
                >
                  {isSubmitting ? "Submitting final review..." : "Submit Final Review"} 
                </button>
              </div>
            ) : pdfUrl ? (
              <div style={{ display: "flex", gap: 20, height: "calc(100vh - 240px)", overflow: "hidden" }}>
                <div style={{ flex: 7, background: "#fff", borderRadius: 14, overflow: "hidden", display: "flex", flexDirection: "column", height: "100%" }}>
                  <PdfViewer file={pdfUrl} />
                </div>
                <div style={{ flex: 3, background: "#fff", borderRadius: 14, boxShadow: "0 4px 12px rgba(0,0,0,.08)", overflow: "hidden" }}>
                  <ReviewSummaryPanel
                    reportName={active.label}
                    summary={localRecommendation[REPORT_RECOMMENDATION_MAP[active.slug] || active.slug] || ""}
                    onSummaryChange={(value) => {
                      const field = REPORT_RECOMMENDATION_MAP[active.slug] || active.slug;
                      if (!field) return;
                      setLocalRecommendation((prev) => ({ ...prev, [field]: value }));
                    }}
                    onSubmit={async () => {
                      const field = REPORT_RECOMMENDATION_MAP[active.slug] || active.slug;
                      if (!field) return;

                      await saveField(field, localRecommendation[field]);
                      setVisited((prev) => prev.includes(active.slug) ? prev : [...prev, active.slug]);

                      const currentIndex = reports.findIndex((r) => r.slug === active.slug);
                      if (currentIndex < reports.length - 1) setActive(reports[currentIndex + 1]);
                    }}
                  />
                </div>
              </div>
            ) : (
              <div style={{ padding: 0, width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
                {loading ? <div style={{ padding: 40, textAlign: "center" }}>Loading section report...</div> : <div style={{ padding: 40 }}>No Report Loaded</div>}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PediatricFinalReviewScreen;